<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="关联用户套餐id" prop="projectSetsId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.projectSetsId" placeholder="请填写关联用户套餐id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目版本id" prop="projectVersionId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.projectVersionId" placeholder="请填写项目版本id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="套餐空间id" prop="projectPositionId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.projectPositionId" placeholder="请填写套餐空间id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="楼层id" prop="storeyId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.storeyId" placeholder="请填写楼层id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="空间id" prop="roomId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.roomId" placeholder="请填写空间id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="位置id" prop="positionId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.positionId" placeholder="请填写位置id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目id" prop="projectId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.projectId" placeholder="请填写项目id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="面积/数量" prop="num"
                :rules="[
                 ]">
              <el-input v-model="inputForm.num" placeholder="请填写面积/数量"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="单价" prop="price"
                :rules="[
                 ]">
              <el-input v-model="inputForm.price" placeholder="请填写单价"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目总价" prop="totalPrice"
                :rules="[
                 ]">
              <el-input v-model="inputForm.totalPrice" placeholder="请填写项目总价"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="单位" prop="unitId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.unitId" placeholder="请填写单位"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="描述" prop="description"
                :rules="[
                  {required: true, message:'描述不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.description" placeholder="请填写描述"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="关联项目组id" prop="linkProjectId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.linkProjectId" placeholder="请填写关联项目组id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="材料方案id" prop="makeupId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.makeupId" placeholder="请填写材料方案id"     ></el-input>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmUserSetMealProjectService from '@/api/cecunmusersetmealproject/cecUnmUserSetMealProjectService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameCn: '',
          projectSetsId: '',
          projectVersionId: '',
          projectPositionId: '',
          storeyId: '',
          roomId: '',
          positionId: '',
          projectId: '',
          num: '',
          price: '',
          totalPrice: '',
          unitId: '',
          description: '',
          linkProjectId: '',
          makeupId: ''
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建UM用户套餐空间项目关联表`
        } else if (method === 'edit') {
          this.title = '修改UM用户套餐空间项目关联表'
        } else if (method === 'view') {
          this.title = '查看UM用户套餐空间项目关联表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmUserSetMealProjectService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmUserSetMealProjectService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
